import { stateFactory } from './state';
import { heatmapColors } from './constants';
import React, { CSSProperties, Component } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import * as Leaflet from 'leaflet';
import L from 'leaflet';
import { FeatureGroup, ImageOverlay, MapContainer, Marker, Polygon, Popup, Tooltip, useMapEvent } from 'react-leaflet';
import { isMobile } from 'react-device-detect';
import HeatmapLayer from '../react-leaflet-heatmap-layer/HeatmapLayer.js';
import '../../../../node_modules/leaflet/dist/leaflet.css';
import '../../../../node_modules/leaflet-draw/dist/leaflet.draw.css';
import { setCurrentNodeID, getNodes } from '../../stores/actions/actions';
import { savePoints, savePolygon, closeSavePointsAndPolygonsNotification } from '../../stores/actions/installerActions';
import { getSystemMap } from '../../stores/actions/dashboardActions';
import { EditControl } from 'react-leaflet-draw';
import EditIcon from '@material-ui/icons/EditOutlined';
import Button from '../../../components/CustomButtons/ButtonTS';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import Snackbar from '../../../components/Snackbar/Snackbar.js';
import './HeatMapInstaller.css';
import ErrorComponent from '../ErrorComponent/ErrorComponent';
import { getHeaderStyle, loaderStyleEmptyCard } from '../../helpers/CustomStyles';
import Loading from '../Loading/Loading';
import { initState } from './initState';
import { devicesIcons } from './devicesIcons';
import ErrorText from '../ErrorComponent/ErrorText';
import { SENSORS } from '../../helpers/Devices';
import { INode, HeatmapInstallerState, PointPx, PointLatLng, EditedVertex, ISystemSettings } from '../../helpers/interfaces';
import { ENDPOINT_DEVICE } from '../../helpers/Devices';
import PopupAutoPanFix from '../HeatMap/PopupAutoPanFix.js';
import MapInitializer from '../HeatMap/MapInitializer';
import pixelToLatLng from '../HeatMap/PixelToLatLng';
import ArrowBack from '@material-ui/icons/ArrowLeft';
import ArrowForward from '@material-ui/icons/ArrowRight';

// helper: convert latlng -> pixel based on bounds and image size
function latLngToPixel(latlng: { lat: number; lng: number }, bounds: Leaflet.LatLngBounds, mapWidth: number, mapHeight: number) {
  const north = bounds.getNorth();
  const south = bounds.getSouth();
  const west = bounds.getWest();
  const east = bounds.getEast();

  const lat = latlng.lat;
  const lng = latlng.lng;

  const xFrac = (lng - west) / (east - west);
  const yFrac = (north - lat) / (north - south);

  return {
    x: Math.round(xFrac * mapWidth),
    y: Math.round(yFrac * mapHeight),
  };
}

const mapLoaderStyle: CSSProperties = {
	position: 'absolute',
	zIndex: 2,
	width: '100%',
	height: '100%',
};

const infrButtonStyle: CSSProperties = {
	background: "linear-gradient(60deg, #26c6da, #00acc1)",
	color: "#fff",
	padding: "20px",
	marginTop: '25px',
	marginLeft: '15px',
	transition: 'color 0.3s',
	fontWeight: '500'
};

const getMapLoaderStyle = (state: boolean): CSSProperties => {
	return {
		...loaderStyleEmptyCard,
		...mapLoaderStyle,
		backgroundColor: state ? 'rgba(0,0,0,0.5)' : 'transparent',
		zIndex: state ? 2 : 0,
	};
};
// TODO: should not use extensive timeouts
const timeoutValue = 2000;

interface HeatMapInstallerProps {
	savePolygonsSuccessfully: boolean;
	savePointsSuccessfully: boolean;
	savePolygonsFailed: boolean;
	savePointsFailed: boolean;
	firstRender: boolean;
	isMapLoading: boolean;
	mapBoundaries: number[][];
	nodes: INode[];
	system: ISystemSettings;
	mapWidth: number;
	mapHeight: number;
	mobileView: boolean;
	mainMapDataBlob: string;
	secondMapDataBlob: string;
	thirdMapDataBlob: string;
	systemId: number;
	closeSavePointsAndPolygonsNotification: () => void;
	getNodes: () => void;
	savePoints: (systemId: number, editedVertices) => void;
	savePolygon: (systemId: number, allPolygons: string[], updatedViaWebsiteAt: string) => void;
	setCurrentNodeID: (nodeId: number) => void;
	updateParent: () => void;
	systemUpdatedViaWebsiteAt: string;
}

class HeatMapInstaller extends Component<HeatMapInstallerProps, HeatmapInstallerState> {
	state = initState;

	// use state.map via MapContainer ref callback
	mapNotificationTimeout: number | undefined = undefined;
	cancelDrawingTimeout: number | undefined = undefined;
	finishDrawingTimeout: number | undefined = undefined;
	updateMarkerTimeout: number | undefined = undefined;
	toolbarTimeout: number | undefined = undefined;

	componentWillUnmount() {
		this.clearAllTimeouts();
	}

	clearAllTimeouts = () => {
		clearTimeout(this.cancelDrawingTimeout);
		clearTimeout(this.finishDrawingTimeout);
		clearTimeout(this.mapNotificationTimeout);
		clearTimeout(this.updateMarkerTimeout);
		clearTimeout(this.toolbarTimeout);
	};

	enableToolbarButtons = () => {
		const { isToolbarActive } = this.state;
		const createButtonInactive: HTMLButtonElement|null = document.querySelector('.leaflet-draw-draw-polygon');
		const editButtonInactive: HTMLButtonElement|null = document.querySelector('.leaflet-draw-edit-edit');
		const deleteButtonInactive: HTMLButtonElement|null = document.querySelector('.leaflet-draw-edit-remove');
		const toolbarButtons = [createButtonInactive, editButtonInactive, deleteButtonInactive];
		if (!isToolbarActive) {
			const enabledButtons = [...toolbarButtons];
			enabledButtons.forEach((btn) => {
				if (!btn) return;
				btn.style.pointerEvents = 'auto';
				btn.style.backgroundColor = '#fff';
			});
			this.setState({ toolbarButtons: enabledButtons, isToolbarActive: true });
		}
	};
	disableToolbarButtons = () => {
		const { isToolbarActive } = this.state;
		const createButtonInactive: HTMLButtonElement|null = document.querySelector('.leaflet-draw-draw-polygon');
		const editButtonInactive: HTMLButtonElement|null = document.querySelector('.leaflet-draw-edit-edit');
		const deleteButtonInactive: HTMLButtonElement|null = document.querySelector('.leaflet-draw-edit-remove');
		const toolbarButtons = [createButtonInactive, editButtonInactive, deleteButtonInactive];
		if (isToolbarActive) {
			const disabledButtons = [...toolbarButtons];
			disabledButtons.forEach((btn) => {
				//@ts-ignore
				btn.style.pointerEvents = 'none';
				//@ts-ignore
				btn.style.backgroundColor = 'rgba(0,0,0,0.3)';
			});
			this.setState({ toolbarButtons: disabledButtons, isToolbarActive: false });
		}
	};

	componentDidMount() {
		const { savePolygonsSuccessfully, savePointsSuccessfully, savePolygonsFailed, savePointsFailed } = this.props;
		if (true && (savePolygonsSuccessfully || savePointsSuccessfully || savePolygonsFailed || savePointsFailed)) {
			this.props.closeSavePointsAndPolygonsNotification();
			this.clearAllTimeouts();
		}
		this.drawPolygonsFromDb(this.props);
	}

	componentDidUpdate(prevProps, prevState) {
		const { showIcons, mapSavedFailed, isWaitingForResponse, isListenersNeeded, deleteError } = this.state;

		const { savePolygonsSuccessfully, savePointsSuccessfully, savePointsFailed, savePolygonsFailed, isMapLoading } = this.props;

		let cancelButton: HTMLButtonElement|null,
			saveButton: HTMLButtonElement|null,
			editButtonActive: HTMLButtonElement|null,
			drawButton: HTMLButtonElement|null,
			createButtonInactive: HTMLButtonElement|null = document.querySelector('.leaflet-draw-draw-polygon'),
			editButtonInactive: HTMLButtonElement|null = document.querySelector('.leaflet-draw-edit-edit'),
			deleteButtonInactive: HTMLButtonElement|null = document.querySelector('.leaflet-draw-edit-remove'),
			cancelDrawingButton: HTMLButtonElement|null,
			finishDrawingButton: HTMLButtonElement|null,
			startDrawingButton: HTMLButtonElement|null;

		if (savePolygonsSuccessfully || savePointsSuccessfully || savePolygonsFailed || savePointsFailed || mapSavedFailed || deleteError) {
			this.mapNotificationTimeout = setTimeout(() => {
				this.props.closeSavePointsAndPolygonsNotification();
				this.props.updateParent();
				this.clearAllTimeouts();
				this.setState({
					mapSavedFailed: false,
					dragError: false,
					deleteError: false,
				});
			}, timeoutValue);

			if (isWaitingForResponse && !isMapLoading) {
				this.setState({ isWaitingForResponse: false });
				this.props.getNodes([this.props.systemId]);
			}

			// check if every toolbar button is not undefined
			if (editButtonInactive && createButtonInactive && deleteButtonInactive) {
				this.disableToolbarButtons();
				this.toolbarTimeout = setTimeout(this.enableToolbarButtons, timeoutValue);
			}

			if (prevState.updateData !== true) {
				this.setState({ updateData: true });
			}
		}

		editButtonActive = document.querySelector('.leaflet-draw-edit-edit.leaflet-draw-toolbar-button-enabled');
		if (showIcons) {
			editButtonActive = document.querySelector('.leaflet-draw-edit-edit.leaflet-draw-toolbar-button-enabled');
			if (editButtonActive !== null) {
				cancelButton = document.querySelector('.leaflet-draw-actions li:nth-child(2) a');
				saveButton = document.querySelector('.leaflet-draw-actions li a');

				if (isListenersNeeded && cancelButton && saveButton) {
					cancelButton.addEventListener('click', this.onCancelButtonClick);
					saveButton.addEventListener('click', this.onSaveButtonClick);
					this.setState({ isListenersNeeded: false });
				}
			}

			drawButton = document.querySelector('.leaflet-draw-draw-polygon.leaflet-draw-toolbar-button-enabled');
			if (drawButton !== null) {
				cancelDrawingButton = document.querySelector("[title='Cancel drawing']");
				finishDrawingButton = document.querySelector("[title='Finish drawing']");
				//@ts-ignore
				cancelDrawingButton.addEventListener('click', this.onCancelDrawingClick);
				//@ts-ignore
				finishDrawingButton.addEventListener('click', this.onFinishDrawingClick);
				this.disableToolbarButtons();
			}
			const drawButtonClicked = document.querySelector('.leaflet-draw-draw-polygon');
			if (drawButtonClicked !== null) {
				startDrawingButton = document.querySelector("[title='Draw a polygon']");
				//@ts-ignore
				startDrawingButton.addEventListener('click', this.onStartDrawingButtonClick);
			}
		}
	}

	componentWillReceiveProps(nextProps) {
		const curWHei = window.innerHeight * 0.55;
		const curWWidth = window.innerWidth * 0.85;
		if (nextProps.mapWidth !== this.props.mapWidth || nextProps.mapHeight !== this.props.mapHeight || this.state.wWidth !== curWWidth || this.state.wHei !== curWHei) {
			if (!this.state.isPolygonEditable) {
				this.drawPolygonsFromDb(nextProps);
			}
		}
	}

	setCurrentNode(node) {
		this.props.setCurrentNodeID(node.id);
	}

	onStartDrawingButtonClick = () => {
		this.disableToolbarButtons();
	};

	onCancelButtonClick = () => {
		console.log('DEBUG', 'onCancelButtonClick');
		const { initialState } = this.state;
		const initialStateArr = [...initialState];
		this.setState({ editedVertices: initialStateArr, polygonsEdited: false });
	};

	onSaveButtonClick = () => {
		console.log('DEBUG', 'onSaveButtonClick');
		const { editedVertices, transformedPolygons } = this.state;

		if (editedVertices.length || transformedPolygons.length) {
			this.setState({
				initialState: editedVertices,
				isWaitingForResponse: true,
				isListenersNeeded: true,
			});
		}
		const cancelButton = document.querySelector('.leaflet-draw-actions li:nth-child(2) a');
		const saveButton = document.querySelector('.leaflet-draw-actions li a');
		if (cancelButton && saveButton) {
			cancelButton.removeEventListener('click', this.onCancelButtonClick);
			saveButton.removeEventListener('click', this.onSaveButtonClick);
		}
	};

	onCancelDrawingClick = () => {
		console.log('DEBUG', 'onCancelDrawingClick');
		this.setState({ isCancelDrawingButtonClicked: true });
		this.cancelDrawingTimeout = setTimeout(() => {
			this.setState({ isCancelDrawingButtonClicked: false, dragError: false });
		}, timeoutValue);
		this.enableToolbarButtons();
	};

	onFinishDrawingClick = () => {
		console.log('DEBUG', 'onFinishDrawingClick');
		const { drawedVerticesAmount } = this.state;
		//minimum amount of vertices to draw polygon is 3:
		if (drawedVerticesAmount > 2) {
			this.setState({
				isFinishDrawingButtonClicked: true,
				drawedVerticesAmount: 0,
			});
			this.finishDrawingTimeout = setTimeout(() => {
				this.setState({
					isFinishDrawingButtonClicked: false,
					dragError: false,
				});
			}, timeoutValue);
			this.save();
		}
		this.enableToolbarButtons();
	};

	handleShowEditIcons = () => {
		this.setState({ showIcons: !this.state.showIcons });
	};

	handleShowNextMap = () => {
		const keys = ["main", "second", "third"].filter(
			key => this.props[`${key}MapDataBlob`]
		);
		const currentIndex = keys.indexOf(this.state.currentMap);
		const nextIndex = (currentIndex + 1) % keys.length;
		this.setState({ currentMap: keys[nextIndex] });
	};

	handleShowPrevMap = () => {
		const keys = ["main", "second", "third"].filter(
			key => this.props[`${key}MapDataBlob`]
		);
		const currentIndex = keys.indexOf(this.state.currentMap);
		const prevIndex = (currentIndex - 1 + keys.length) % keys.length;
		this.setState({ currentMap: keys[prevIndex] });
	};

	getCurrentMapUrl = () => {
		switch (this.state.currentMap) {
			case "main":
				return this.props.mainMapDataBlob;
			case "second":
				return this.props.secondMapDataBlob;
			case "third":
				return this.props.thirdMapDataBlob;
			default:
				return this.props.mainMapDataBlob;
		}
	};

	heatmapPoints() {
		const points:any[] = [];
		this.props.nodes.forEach((node) => {
			let power = 0;
			if (node.LatestKnownThreatLevel !== 'none' && node.LatestKnownThreatLevel !== 'unknown_or_NA' && node.active) {
				power = parseInt(node.LatestKnownThreatLevel.split('L')[1], 10) * 25;
				points.push([node.mapPositionX, node.mapPositionY, power]);
			}
		});
		return points;
	}

	parsePolygons = (polygons) => {
	    const transformedResultPolygon: string[] = [];
		polygons.forEach((currentPolygon) => {
			let resultPolygonsString = '';
			currentPolygon.forEach((currentPoint, index) => {
				if (index === 0) {
					resultPolygonsString += `(${currentPoint.x}, ${currentPoint.y},`;
				} else if (index === currentPolygon.length - 1) {
					resultPolygonsString += `${currentPoint.x}, ${currentPoint.y})`;
				} else {
					resultPolygonsString += `${currentPoint.x}, ${currentPoint.y},`;

				}
			});
			resultPolygonsString = resultPolygonsString.replace(/ /g, '');
			transformedResultPolygon.push(resultPolygonsString);
		});
		return transformedResultPolygon;
	}

    polygonsLatLngsToPxs = (polygons) => {
        const { bounds } = this.state;
        const { mapWidth, mapHeight } = this.props;
        if (!bounds) {
            console.error('polygonsLatLngsToPxs: bounds not ready');
            return [];
        }
        const polygonsPx: PointPx[][] = [];
		polygons.forEach((polygonLatLng) => {
			const currentPolygonPx: PointPx[] = [];
			polygonLatLng.forEach((vertex: PointLatLng) => {
				const px = latLngToPixel(vertex, bounds, mapWidth, mapHeight);
				currentPolygonPx.push(px as unknown as PointPx);
			});
			polygonsPx.push(currentPolygonPx);
		});
		return polygonsPx;
    }
	save = () => {
		const { transformedPolygons, editedVertices, polygonsEdited} = this.state;
		const { systemId, savePoints, savePolygon, systemUpdatedViaWebsiteAt } = this.props;
		if (transformedPolygons.length && polygonsEdited) {
			savePolygon(systemId, transformedPolygons, systemUpdatedViaWebsiteAt);
			this.props.updateParent();
		}
		if (editedVertices.length) {
			editedVertices.forEach((vertex) => {
				const findIndex = this.props.nodes.findIndex(({ id }) => id === vertex.id);
				vertex.updatedViaWebsiteAt = this.props.nodes[findIndex].updatedViaWebsiteAt;
			});
			savePoints(systemId, editedVertices);
			this.props.updateParent();
		}
		this.setState({ transformedPolygons: [], polygonsEdited: false });
	};

	// Runs after entering EDIT mode
	_onEditStart = (e) => {
		console.info('_onEditStart', e);
		const draggablePoints: Element[] = [...document.querySelectorAll('.leaflet-marker-icon')];
		draggablePoints.forEach((draggablePoint) => ((draggablePoint as HTMLDivElement).style.opacity = '0.6'));

		this.setState({ isPointDraggable: true, isPolygonEditable: true });
		this.disableToolbarButtons();
	};

	// Runs after exiting EDIT mode. After _onEdited
	_onEditStop = (e) => {
		console.info('_onEditStop', e);
		const draggablePoints: Element[] = [...document.querySelectorAll('.leaflet-marker-icon')];
		draggablePoints.forEach((draggablePoint) => ((draggablePoint as HTMLDivElement).style.opacity = '1.0'));

		this.setState({ isPointDraggable: false, isPolygonEditable: false });
		this.enableToolbarButtons();
	};

	// Runs after clicking SAVE button
	_onEdited = (e) => {
		console.info('_onEdited', e);
		const editedPolygons = e.layers._layers; // keys of polygons that were edited

		const { dragError } = this.state;

		if (!dragError) {
			const allPolygons = {};
            for (let key in e.target._layers) {
                if (e.target._layers[key].hasOwnProperty('_latlngs')) {
                    allPolygons[key] = e.target._layers[key]['_latlngs'][0];
                }
            }
            // extract from event result which polygons were edited and assign current values:
            for (let key in editedPolygons) {
                allPolygons[key] = editedPolygons[key]['_latlngs'][0];
            }
            let filteredPolygonsLatLng:any[] = []
            for (let key in allPolygons) {
                filteredPolygonsLatLng.push(allPolygons[key]);
            }
			const polygonsPxs = this.polygonsLatLngsToPxs(filteredPolygonsLatLng);
			const parsedPolygons = this.parsePolygons(polygonsPxs);
			this.setState({ mapSavedFailed: false, transformedPolygons: parsedPolygons }, () => {this.save();});
		} else {
			this.setState({ mapSavedFailed: true, dragError: false }, () => {this.save();});
		}
	};

	_onCreated = (e) => {
		console.info('_onCreated', e);
		const state = stateFactory(this.props.mapBoundaries, this.heatmapPoints());
		const { dragError, bounds } = this.state;
		const { mapWidth, mapHeight } = this.props;
		if (!bounds) return; // wait until bounds ready

		const currentPolygon = e.layer['_latlngs'][0];

		this.setState({ dragError: false });
		currentPolygon.forEach((vertex) => {
			if (this.vertexOutsideMap(vertex, bounds.getSouthWest(), bounds.getNorthEast())) {
				return this.setState({ dragError: true });
			}
		});

		if (!dragError) {
			this.setState({ mapSavedFailed: false });
			const allPolygons = {};
			for (let key in e.target._layers) {
				if (e.target._layers[key].hasOwnProperty('_latlngs')) {
					if (Array.isArray(e.target._layers[key]['_latlngs'][0])) {
						allPolygons[key] = e.target._layers[key]['_latlngs'][0];
					}
				}
			}
			const polygonsLatLng:any[] = [];
			for (let key in allPolygons) {
				polygonsLatLng.push(allPolygons[key]);
			}
			const polygonsPx = this.polygonsLatLngsToPxs(polygonsLatLng);
			const resultPolygons = this.parsePolygons(polygonsPx);
			this.setState({ transformedPolygons: resultPolygons, isWaitingForResponse: true, polygonsEdited: true }, () => {this.save();});
		} else {
		    this.setState({ mapSavedFailed: true, dragError: false, polygonsEdited:true  }, () => {this.save();});
		}
	};

	_onMounted = (e) => {
		console.info('_onMounted', e);
	};

	_onDeleteStart = (e) => {
		console.info('_onDeleteStart', e);
		// hide clear all layers button:
		//@ts-ignore
		const clearAllLayersButton: HTMLAnchorElement = document.querySelector("[title='Clear all layers']");
		clearAllLayersButton.style.display = 'none';
		this.disableToolbarButtons();
	};

	_onDeleteStop = (e) => {
		console.info('_onDeleteStop', e);
		this.enableToolbarButtons();
	};

	_onDeleted = (e) => {
		console.log('_onDeleted: ', e);
		const currentLayers = e['target']['_layers'];
		// current polygons in px:
		const currentPolygonsLatLngs: PointLatLng[][] = [];
		// check which layers are polygons:
		for (const prop in currentLayers) {
			// only polygon has _latlngs property:
			if (currentLayers[prop].hasOwnProperty('_latlngs')) {
				// property _parts has array with Points in px
				currentPolygonsLatLngs.push(...currentLayers[prop]['_latlngs']);
			}
		}
		// show error if user deletes all polygons and block sending request to server:
		if (!currentPolygonsLatLngs.length) {
			return this.setState({ deleteError: true });
		}
		const polygonsPx: PointPx[][] = this.polygonsLatLngsToPxs(currentPolygonsLatLngs);
		const transformedResultPolygon: string[] = this.parsePolygons(polygonsPx);
		this.setState({ transformedPolygons: transformedResultPolygon, deleteError: false, isWaitingForResponse: true, polygonsEdited:true }, () => {this.save();});
	};

	updateMarker = (e, node) => {
		const { bounds } = this.state;
		let { editedVertexCurrentState, editedVertexPrevState } = this.state;
		const { mapWidth, mapHeight } = this.props;
		if (!bounds) return;

		const editedVertexLatLng: PointLatLng = e.target._latlng;
		let editedVertexPx: EditedVertex|null = latLngToPixel(editedVertexLatLng, bounds, mapWidth, mapHeight) as unknown as EditedVertex;
		editedVertexPx.id = node.id;
		editedVertexPx.updatedAt = node.updatedAt;
		editedVertexPx.systemId = node.systemId;
		let editedVertices = this.state.editedVertices; //edited vertex in px with id and updatedAt
		editedVertexCurrentState = editedVertexPx;

		if (editedVertexPx.x < 0 || editedVertexPx.y < 0 || editedVertexPx.x > mapWidth || editedVertexPx.y > mapHeight) {
			editedVertexPx = editedVertexPrevState;
			this.setState({ dragError: true });
			this.updateMarkerTimeout = setTimeout(() => {
				this.setState({ dragError: false });
			}, timeoutValue);
		} else {
			const nodeIndex = editedVertices.findIndex((el) => el.id === (editedVertexPx as EditedVertex).id);
			if (nodeIndex !== -1) {
				editedVertices.splice(nodeIndex, 1);
			}
			//@ts-ignore
			editedVertexPrevState = editedVertexCurrentState;
			//@ts-ignore
			editedVertexPrevState.updatedAt = node.updatedAt;
			//@ts-ignore
			editedVertices.push(editedVertexPrevState);
			this.setState({
				editedVertices: editedVertices, //zaktualizowanie edytowanych punktow
				editedVertexPrevState: editedVertexPrevState, //dzieki temu punkt wraca w ostatnie miejsce, gdy wyjdziemy nim poza mape
				dragError: false,
			});
		}
	};
    updatePopupState = (bool) => {
        this.setState({popupOpen: bool});
    };

	handleEditVertex = (e) => {
		const { bounds } = this.state;
		if (!bounds) return;

		const currentPolygons:any[] = [];
		e.poly._latlngs[0].forEach((el) => {
			currentPolygons.push([el.lat, el.lng]);
		});

		this.setState({ dragError: false, polygonsEdited:true });
		currentPolygons.forEach((el, i) => {
			if (this.vertexOutsideMap({ lat: el[0], lng: el[1] }, bounds.getSouthWest(), bounds.getNorthEast())) {
				return this.setState({ dragError: true });
			}
		});
	};

	handleDrawVertex = (e) => {
		const { bounds } = this.state;
		if (!bounds) return;

		const currentVertices: any[] = [];
		const currentKeys: any[] = [];

		for (const key in e.layers['_layers']) {
			currentKeys.push(key);
		}

		currentKeys.forEach((key, i) => {
			currentVertices.push(e.layers['_layers'][key]['_latlng']);
		});

		this.setState({
			dragError: false,
			drawedVerticesAmount: currentKeys.length,
		});
		currentVertices.forEach((el, i) => {
			if (this.vertexOutsideMap(el, bounds.getSouthWest(), bounds.getNorthEast())) {
				return this.setState({ dragError: true });
			}
		});
	};

	renderMobileNotifications = () => {
		const { dragError, mapSavedFailed, deleteError } = this.state;
		const { savePolygonsSuccessfully,  savePointsSuccessfully, savePolygonsFailed , savePointsFailed, mobileView } = this.props;
		const headerStyle: CSSProperties = getHeaderStyle(!savePolygonsSuccessfully || !savePointsSuccessfully);

		if (
			mobileView &&
			(savePolygonsFailed || savePointsFailed || mapSavedFailed || dragError || savePointsSuccessfully || savePolygonsSuccessfully || deleteError)
		) {
			return (
				<GridItem xs={12}>
					<h5
						className={
							savePolygonsSuccessfully && savePointsSuccessfully
								? 'save-polygon-and-points-successfully'
								: dragError
									? 'show-drag-error'
									: 'save-polygon-and-points-failed'
						}
						style={{ ...headerStyle, textAlign: 'center' }}
					>
						{savePolygonsSuccessfully && savePointsSuccessfully
							? 'Map was saved successfully'
							: dragError
								? 'You can not save map if any point is outside the map'
								: 'Map was not saved'}
					</h5>
				</GridItem>
			);
		}
	};

	closeDragError = () => {
		this.setState({ dragError: false });
	};

	closeMapSaveError = () => {
		this.setState({ mapSavedFailed: false });
	};

	closeDeleteError = () => {
		this.setState({ deleteError: false });
	};

	// TODO: Vert duplikuje Leaflet.LatLang
	vertexOutsideMap(vertex: PointLatLng, southWestMapCorner: Leaflet.LatLng, northEastMapCorner: Leaflet.LatLng): boolean {
		return (
			vertex.lat < southWestMapCorner.lat ||
			vertex.lat > northEastMapCorner.lat ||
			vertex.lng < southWestMapCorner.lng ||
			vertex.lng > northEastMapCorner.lng
		);
	}

	drawPolygonsFromDb = (nextProps) => {
		const state = stateFactory(nextProps.mapBoundaries, this.heatmapPoints());
		const { mapWidth, mapHeight } = nextProps;
		if (!mapWidth || !mapHeight) {
			return;
		}
		const { bounds, isPolygonEditable, isPolygonUpdated } = this.state;

		if (!bounds) {
			// bounds not ready yet; polygons will be computed when MapInitializer calls onMapReady
			return;
		}
		const boundaryOutlineUnprojected:any[] = [];
		//drawing polygons from database:
		state.boundaryOutline.forEach((polygon) => {
			const currentPolygon:any[] = [];
			polygon.forEach((vertex, i) => {
				const latlng = pixelToLatLng(vertex[0], vertex[1], bounds, mapWidth, mapHeight);
				currentPolygon.push([latlng.lat, latlng.lng]);
			});
			boundaryOutlineUnprojected.push(currentPolygon);
		});

		if ((this.state.neededRescaling === 0 || this.state.neededRescaling !== this.state.scaleFactor) && !isPolygonEditable) {
			this.setState({
				neededRescaling: this.state.scaleFactor || 0,
				polygons: [...boundaryOutlineUnprojected],
				wHei: window.innerHeight * 0.55,
				wWidth: window.innerWidth * 0.85
			});
		}
		if (!isPolygonUpdated) {
			this.setState({ polygons: [...boundaryOutlineUnprojected], isPolygonUpdated: true });
		}
	}

	renderPopup = (node: INode, i: number) => {
		const name = node.name;
		const isInclinometer = node.MainSensorType === 'inclinometer';
		let obstruction = '';
		let deflection = '';
		let threshold = '';

		if (node.CanMeasure && (node.SystemVersion !== 'W2' || node.W2Operational === true)) {
			// calculate deflection value:
			if (node.PermissibleValue !== null && node.LatestKnownCalculatedDeflection !== null) {
				deflection = `Deflection: 0%`;
				if (node.PermissibleValue !== 0) {
					const deflectionPercent = `${Math.round(node.LatestKnownCalculatedDeflection * 100 / node.PermissibleValue)}%`;
					const deflectionValue = node.LatestKnownCalculatedDeflection.toFixed(isInclinometer ? 3 : 0);
					const unit = isInclinometer ? '°' : 'mm';
					deflection = `Deflection: ${deflectionPercent} (${deflectionValue}${unit})`;
				}
			} else {
				deflection = `Deflection: --`;
			}

			// calculate obstructing value:
			let baseDistanceCorrectionValue;
			if (node.BaseDistanceCorrection !== null && node.ObstructionStatus) {
				if (Math.abs(node.BaseDistanceCorrection) < 99) {
					baseDistanceCorrectionValue = `: ca. ${(Math.abs(node.BaseDistanceCorrection) / 10).toFixed()}cm`;
				} else if (Math.abs(node.BaseDistanceCorrection) < 999) {
					baseDistanceCorrectionValue = `: ca. ${(Math.abs(node.BaseDistanceCorrection) / 10).toFixed()}cm`
				} else if (Math.abs(node.BaseDistanceCorrection) < 9999) {
					baseDistanceCorrectionValue = `: ca. ${(Math.abs(node.BaseDistanceCorrection) / 1000).toFixed(1)}m`
				} else {
					baseDistanceCorrectionValue = `: ca. ${(Math.abs(node.BaseDistanceCorrection) / 1000).toFixed()}m`
				}
				obstruction = `Node obstructed${node.BaseDistanceCorrection !== 0 ? baseDistanceCorrectionValue : ""}`;
			}
		}
		if (node.LatestKnownThreatLevel !== 'none' && node.LatestKnownThreatLevel !== 'unknown_or_NA' && node.active) {
			threshold = `Threshold: ${node.LatestKnownThreatLevel}`;
		}

		return (
			<Popup key={`popup-${i}`} autoPan={false}>
				<NavLink to={`/devices/${node.id}/graph`} key={`node-name-${name}`}>
					<div>{name}</div>
					<div>{deflection}</div>
					<div>{obstruction}</div>
					<div>{threshold}</div>
				</NavLink>
			</Popup>
		);
	}

	render() {
		try {
			const state = stateFactory(this.props.mapBoundaries, this.heatmapPoints());
			const {
				mapWidth,
				mapHeight,
				nodes,
				savePolygonsFailed,
				savePointsFailed,
				savePolygonsSuccessfully,
				savePointsSuccessfully,
				closeSavePointsAndPolygonsNotification,
				mobileView,
				isMapLoading,
				systemMapDataBlob
			} = this.props;

			const {
				map,
				editedVertices,
				polygons,
				scrollWheelZoom,
				isPointDraggable,
				showIcons,
				dragError,
				isWaitingForResponse,
				deleteError,
				bounds
			} = this.state;
			const crsSimple = Leaflet.CRS.Simple;

			const wHei = window.innerHeight * 0.55;
			const wWidth = window.innerWidth * 0.85;

			let maxThreatLvl = 0;
			// build markers only when bounds ready
			const markers = (nodes || []).map((node, i) => {
				if (!bounds) return <React.Fragment key={`empty-${i}`} />;
				if (!this.state.showAllDevices && (node.DeviceRole !== ENDPOINT_DEVICE && !node.CanMeasure || (node.SystemVersion === 'W2' && !node.W2Operational))) {
					return <></>
				}
				let content;

				let threatLvl = 0;
				if (node.LatestKnownThreatLevel === 'unknown_or_NA' || !node.active) {
					threatLvl = 0;
				} else if (node.LatestKnownThreatLevel === 'none') {
					threatLvl = 1;
				} else {
					threatLvl = parseInt(node.LatestKnownThreatLevel.split('L')[1], 10) + 1;
				}

				// set heatmap color
				if (threatLvl > maxThreatLvl) {
					maxThreatLvl = threatLvl;
				}
				//if device is an endpoint device:
				if (node.MainSensorType === SENSORS.Laser.valueOf()) {
					content = devicesIcons.laser[threatLvl];
					//if device is obstructed:
					if (!!node.ObstructionStatus) {
						content = devicesIcons.laserObstructed[threatLvl];
					}
					//if device isn't active:
					if (node.active === false) {
						content = devicesIcons.laserNotActive;
					}
					//if W2 device isn't operational:
					if (node.SystemVersion === 'W2' && node.W2Operational === false) {
						content = devicesIcons.laserNotOperational;
					}
				}
				//if device is an inclinometer:
				else if (node.MainSensorType === SENSORS.Iclinometer.valueOf()) {
					content = devicesIcons.inclinometer[threatLvl];
					//if device is obstructed:
					if (!!node.ObstructionStatus) {
						content = devicesIcons.inclinometerObstructed[threatLvl];
					}
					//if device isn't active:
					if (node.active === false) {
						content = devicesIcons.inclinometerNotActive;
					}
					//if W2 device isn't operational:
					if (node.SystemVersion === 'W2' && node.W2Operational === false) {
						content = devicesIcons.inclinometerNotOperational;
					}
				}
				//if device is an access device or retransmitter:
				else if (node.name !== 'Gateway') {
					content = devicesIcons.infrastructureDeviceActiveOperational;

                    //if device isn't active:
					if (node.active === false) {
						content = devicesIcons.infrastructureDeviceNotActive;
					}
					//if W2 device isn't operational:
					if (node.SystemVersion === 'W2' && node.W2Operational === false) {
						content = devicesIcons.infrastructureDeviceNotOperational;
					}
                //if device is a gateway:
				} else {
                    content = devicesIcons.infrastructureDeviceActiveOperational;
				}

				// compute latlng from pixel coords using bounds
				const nLatLng = pixelToLatLng(node.mapPositionX, node.mapPositionY, bounds, mapWidth, mapHeight);
				let n = Leaflet.latLng(nLatLng.lat, nLatLng.lng);
				if (editedVertices !== undefined && editedVertices.length !== 0) {
					editedVertices.forEach((editedVertex) => {
						if (editedVertex.id === node.id) {
							const ev = pixelToLatLng(editedVertex.x, editedVertex.y, bounds, mapWidth, mapHeight);
							n = Leaflet.latLng(ev.lat, ev.lng);
						}
					});
				}

				return (
					<Marker
						icon={content}
						key={'wisene-sni-' + i}
						position={[n.lat, n.lng]}
						center={[n.lat, n.lng]}
						onClick={(e) => this.setCurrentNode(node)}
						draggable={isPointDraggable}
						eventHandlers={{
							click: (e) => this.setCurrentNode(node),
							dragend: (e) => this.updateMarker(e, node),
							popupopen: () => this.updatePopupState(true),
							popupclose: () => this.updatePopupState(false),
						}}
						onEdited={this._onEdited}
					>
                        { this.state.popupOpen ? <Tooltip opacity={0} children={[]}></Tooltip> :
                        <Tooltip
                            key={`tooltip-${i}`}
                            direction={'left'}
                            offset={[0, 10]}
                        >
							{node.name}
					    </Tooltip>
					    }
						{this.renderPopup(node, i)}
					</Marker>
				);
			});

			const heatmapUnprojected:any[] = [];
			if (bounds) {
				state.heatmap.forEach((vertex) => {
					const latlng = pixelToLatLng(vertex[0], vertex[1], bounds, mapWidth, mapHeight);
					heatmapUnprojected.push([latlng.lat, latlng.lng, vertex[2]]);
				});
			}
			return (
				<ErrorComponent
					message={'Map was not rendered. Try to refresh the page.'}
					Children
				// style={mapWrapperStyle}
				>
					<div style={{ position: 'relative' }}>
						{isWaitingForResponse ? (
							<div style={getMapLoaderStyle(isWaitingForResponse)}>
								<Loading transform={0.85} height={90} width={70} color='gray' />
							</div>
						) : null}
						{!isWaitingForResponse && (isMapLoading || !mapWidth) ? (
							<div style={loaderStyleEmptyCard}>
								<Loading transform={0.85} height={90} width={70} color='gray' />
							</div>
						) : (
							<div style={{ zIndex: 1 }}>
								<div>
									<Button style={infrButtonStyle} onClick={()=>this.setState({showAllDevices: !this.state.showAllDevices})}>
										{ this.state.showAllDevices ? 'Show operational measuring devices' : 'Show all devices' }
									</Button>
								</div>
								<MapContainer
									crs={crsSimple}
									key={'wisenemap'}
									maxBounds={bounds || undefined}
									center={state.center}
									style={{
										width: 'calc(100% - 15px)',
										height: wHei,
										margin: '15px 15px 0 15px',
										borderRadius: '5px',
										zIndex: 1,
									}}
									zoom={state.zoom}
									minZoom={state.minZoom}
									maxZoom={state.maxZoom}
									zoomSnap={state.zoomSnap}
									zoomDelta={state.zoomDelta}
									wheelPxPerZoomLevel={state.wheelPxPerZoomLevel}
									infinite={state.infinite}
									scrollWheelZoom={scrollWheelZoom}
									zoomAnimation={false}
									dragging={!isMobile}
									tap={false}
									bounceAtZoomLimits={false}
								>
									{/* MapInitializer will compute bounds and set map state */}
									<MapInitializer
										mapWidth={mapWidth}
										mapHeight={mapHeight}
										zoomProjectionMargin={state.zoomProjectionMargin}
										onMapReady={(m, computedBounds, zoomArg, scaleFactor) => {
											if (this.state.map !== m || this.state.bounds !== computedBounds || this.state.zoomArg !== zoomArg) {
												this.setState({ map: m, bounds: computedBounds, zoomArg, scaleFactor }, () => {this.drawPolygonsFromDb(this.props);});
												m.on('click', () => this.setState((prev) => ({ scrollWheelZoom: !prev.scrollWheelZoom })));
												m.on('blur', () => this.setState({ scrollWheelZoom: false }));
											}
										}}
									/>
								<MapEvents
									onMapClick={() =>
										this.setState({ scrollWheelZoom: !this.state.scrollWheelZoom }, () => {
											this.state.scrollWheelZoom ? this.state.map.scrollWheelZoom.disable() : this.state.map.scrollWheelZoom.enable();
										})
									}
									onMapBlur={() =>
										this.state.map.scrollWheelZoom.disable()
									}
								/>
									<PopupAutoPanFix />
									<FeatureGroup interactive={true}>
										{showIcons ? (
											<EditControl
												draw={{
												rectangle: false,
												polyline: false,
												circle: false,
												marker: false,
												circlemarker: false,
											}}
											onEdited={this._onEdited}
											onCreated={this._onCreated}
											onDeleted={this._onDeleted}
											onMounted={this._onMounted}
											onEditStart={this._onEditStart}
											onEditStop={this._onEditStop}
											onDeleteStart={this._onDeleteStart}
											onDeleteStop={this._onDeleteStop}
											onEditVertex={(e) => this.handleEditVertex(e)}
											onDrawVertex={(e) => this.handleDrawVertex(e)}
											key={'features-group'}
										/>
										) : (
											''
										)}
										{/* polygons visible in edit mode */}
										{(polygons || []).map((polygonEditLayer, i) => {
											return (
												<Polygon
													showArea={true}
													color={'black'}
													fill={false}
													positions={polygonEditLayer}
													zIndex={201}
													key={`polygon-edit-layer-${i}`}
											/>
											);
										})}
									</FeatureGroup>

									{bounds && <ImageOverlay bounds={bounds} url={this.getCurrentMapUrl()} />}
									{markers}

									{(polygons || []).map((polygonContour, i) => {
										return (
											<HeatmapLayer
												minOpacity={0.15}
												fitBoundsOn
												useFlyTo
												points={heatmapUnprojected}
												pointsHeatmapBoundry={polygonContour}
												radius={150}
												max={(maxThreatLvl - 1) * 25}
												blur={40}
												gradient={{ '1': heatmapColors[maxThreatLvl] }}
												longitudeExtractor={(m) => m[1]}
												latitudeExtractor={(m) => m[0]}
												intensityExtractor={(m) => parseFloat(m[2])}
												key={`heatmap-layer-${i}`}
											/>
										);
										})}
								</MapContainer>
								</div>
							)}
						</div>
						{!mobileView ? (
							<>
								<Snackbar close closeNotification={closeSavePointsAndPolygonsNotification} color='danger' message='Map was not saved.' open={savePointsFailed || savePolygonsFailed} place='tc' key='server-error-notification'/>
								<Snackbar close closeNotification={this.closeMapSaveError} color='danger' message='Map was not saved. At least one point is located outside the map' open={this.state.mapSavedFailed} place='tc' key='local-error-notification'/>
								<Snackbar color='danger' message='You can not save map if any point is outside the map' open={dragError} place='tc' key='drag-error-notification'/>
								<Snackbar close closeNotification={this.closeDeleteError} color='danger' message='Map has to assign at least one polygon' open={deleteError} place='tc' key='delete-error-notification'/>
								<Snackbar close closeNotification={closeSavePointsAndPolygonsNotification} color='success' message='Map was saved successfully' open={(savePolygonsSuccessfully || savePointsSuccessfully) && !savePointsFailed && !savePolygonsFailed} place='tc' key='save-map-success-notification'/>
							</>
						) : (
							this.renderMobileNotifications()
						)}
						{!isWaitingForResponse && (isMapLoading || !mapWidth) ? null : (
							<GridContainer>
								<GridItem xs={12} style={{ display: 'flex', alignItems: 'center', margin: '10px 15px 0 0' }}>
									
									<div style={{ display: 'flex', flex: 1, justifyContent: 'center', gap: '8px' }}>
									{(!!this.props.secondMapDataBlob || !!this.props.thirdMapDataBlob) && <>
										
									<Button size='lg' simple justIcon color='info' onClick={this.handleShowPrevMap}>
										<ArrowBack />
									</Button>
									<Button size='lg' simple justIcon color='info' onClick={this.handleShowNextMap}>
										<ArrowForward />
									</Button>		
										</>}

									</div>

									<div style={{ marginLeft: 'auto' }}>
									<Button
										size='sm'
										simple
										justIcon
										color='info'
										onClick={this.handleShowEditIcons}
										disabled={
										isWaitingForResponse ||
										savePolygonsSuccessfully ||
										savePointsSuccessfully ||
										savePolygonsFailed ||
										savePointsFailed
										}
									>
										<EditIcon />
									</Button>
									</div>

								</GridItem>
							</GridContainer>
						)}
				</ErrorComponent>
			);
		} catch (error) {
			return <ErrorText message='Corrupted map data. Try to refresh page.'></ErrorText>;
		}
	}
}

function MapEvents({ onMapClick, onMapBlur }) {
  useMapEvent('click', () => {
	onMapClick();
  });

  useMapEvent('blur', () => {
	onMapBlur();
  });

  return null;
}

const mapStateToProps = (state) => {
	return {
		nodes: state.dashboard.nodes,
		system: state.dashboard.system,
		savePolygonsSuccessfully: state.installer.savePolygonsSuccessfully,
		savePointsSuccessfully: state.installer.savePointsSuccessfully,
		savePolygonsFailed: state.installer.savePolygonsFailed,
		savePointsFailed: state.installer.savePointsFailed,
		systemUpdatedViaWebsiteAt: state.installer.systemUpdatedViaWebsiteAt,
		mobileView: state.dashboard.mobileView,
		isMapLoading: state.dashboard.isMapLoading,
		secondMapDataBlob: state.dashboard.systemSecondMapDataBlob,
		thirdMapDataBlob: state.dashboard.systemThirdMapDataBlob,
	};
};

const actions = {
	setCurrentNodeID,
	savePoints,
	savePolygon,
	closeSavePointsAndPolygonsNotification,
	getSystemMap,
	getNodes,
};

export default connect(mapStateToProps, actions)(HeatMapInstaller);
